import React, { useEffect, useState } from "react";
import axios from "axios";
import { ArrowUpCircle, Check, X, ChevronDown, ChevronUp } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const fmt = (n) => "Rp " + Math.round(Number(n || 0)).toLocaleString("id-ID");

export const UpgradeRequestsPanel = ({ onChanged }) => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(true);
  const [busy, setBusy] = useState("");

  const load = async () => {
    try {
      const res = await axios.get(`${BACKEND_URL}/api/upgrade-requests?status=pending`, { withCredentials: true });
      setItems(res.data);
    } catch (e) { /* ignore */ }
  };
  useEffect(() => { load(); }, []);

  const decide = async (id, action) => {
    const catatan_admin = action === "reject" ? (window.prompt("Alasan penolakan (opsional):") ?? "") : "";
    setBusy(id);
    try {
      await axios.patch(`${BACKEND_URL}/api/upgrade-requests/${id}`, { action, catatan_admin }, { withCredentials: true });
      await load();
      if (onChanged) onChanged();
    } catch (e) {
      alert(e.response?.data?.detail || "Gagal memproses pengajuan");
    } finally {
      setBusy("");
    }
  };

  if (items.length === 0) return null;

  return (
    <div className="mb-6 rounded-2xl border border-cyan-500/40 bg-cyan-500/5" data-testid="upgrade-requests-panel">
      <button onClick={() => setOpen((o) => !o)} className="w-full flex items-center justify-between px-4 py-3">
        <span className="text-sm font-bold text-white flex items-center gap-2">
          <ArrowUpCircle className="w-4 h-4 text-cyan-400" /> Pengajuan Upgrade Paket dari Portal Pelanggan
          <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-cyan-500 text-white" data-testid="upgrade-requests-count">{items.length}</span>
        </span>
        {open ? <ChevronUp className="w-4 h-4 text-slate-400" /> : <ChevronDown className="w-4 h-4 text-slate-400" />}
      </button>
      {open && (
        <div className="px-4 pb-4 space-y-2">
          {items.map((r) => (
            <div key={r.id} className="p-3 rounded-xl bg-[#0d1527] border border-slate-800 flex flex-col sm:flex-row sm:items-center gap-3" data-testid={`upgrade-request-${r.id}`}>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-white">{r.pelanggan_nama} <span className="text-[11px] text-slate-400 font-mono">({r.no_layanan})</span></p>
                <p className="text-xs text-slate-300 mt-0.5"><span className="text-slate-500">{r.paket_lama_nama || "-"} ({fmt(r.paket_lama_harga)})</span> → <b className="text-cyan-300">{r.paket_baru_nama}</b> ({fmt(r.paket_baru_harga)})</p>
                {r.catatan && <p className="text-[11px] text-slate-500 italic mt-0.5">"{r.catatan}"</p>}
                <p className="text-[10px] text-slate-500 mt-0.5">{new Date(r.created_at).toLocaleString("id-ID")} • HP {r.no_hp}</p>
              </div>
              <div className="flex gap-2 shrink-0">
                <button disabled={busy === r.id} onClick={() => decide(r.id, "approve")} className="px-3 py-1.5 rounded-lg bg-emerald-500/15 text-emerald-300 border border-emerald-500/40 text-xs font-semibold flex items-center gap-1 hover:bg-emerald-500/25 disabled:opacity-50" data-testid={`approve-upgrade-${r.id}`}><Check className="w-3.5 h-3.5" /> Setujui</button>
                <button disabled={busy === r.id} onClick={() => decide(r.id, "reject")} className="px-3 py-1.5 rounded-lg bg-rose-500/15 text-rose-300 border border-rose-500/40 text-xs font-semibold flex items-center gap-1 hover:bg-rose-500/25 disabled:opacity-50" data-testid={`reject-upgrade-${r.id}`}><X className="w-3.5 h-3.5" /> Tolak</button>
              </div>
            </div>
          ))}
          <p className="text-[10px] text-slate-500">Menyetujui akan mengubah paket & profil Mikrotik pelanggan di data billing (perubahan profil di router dilakukan lewat menu Jaringan).</p>
        </div>
      )}
    </div>
  );
};
